/**
 * The ID-check bells (docs/TenantIdVerification.md §7): the server writes `identity_declined` with
 * `{ reason }` (a §3 reason code); the bell body is that reason's sentence in the viewer's language.
 * An unknown or missing code reads as `other`, never as the raw key.
 */
export const IDENTITY_REASON_CODES = ['photo', 'face', 'expired_document', 'name_mismatch', 'copy', 'underage', 'other'] as const;
export type IdentityReasonCode = (typeof IDENTITY_REASON_CODES)[number];

export function identityDeclinedReasonKey(payload: unknown): string {
  const raw = payload && typeof payload === 'object' && !Array.isArray(payload)
    ? (payload as Record<string, unknown>).reason
    : null;
  const code = (IDENTITY_REASON_CODES as readonly unknown[]).includes(raw) ? (raw as IdentityReasonCode) : 'other';
  return `notifications.identity_reasons.${code}`;
}
